if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.atpRequest.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.sku = this.dataset.sku;
      this.getCountryCode();
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getCountryCode(){
      fetch('/browsing_context_suggestions.json', {
        headers: {
          'dataType': 'application/json' 
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); 
      })
      .then(data => {
        localStorage.setItem('country_code',data.detected_values.country.handle);
      })
      .catch(error => {
        console.error('Error fetching data:', error); 
      }); 
    }

     formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    }

    atpRequest(evt) {
      evt.preventDefault();

      if(this.sku == '' || this.sku == 'undefined' || this.sku == null){
        this.onSubmitHandler();
        return;
      }
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const countryCode = localStorage.getItem('country_code');
      //const qty = document.querySelector('[name=quantity]').value;
      const quantityElement = document.querySelector('[name=quantity]');
      let qty;
      if (quantityElement) {
           qty = quantityElement.value;
      } else {
           qty = 1;
      } 
      let custNum;
      if(countryCode == 'US'){
        custNum = '4700';
      }else{
        custNum = '6700';
      }
      const atpUrl = 'https://brandography-dev.dreamhosters.com/atpLogic.php';
      const requestObj = {
        CustNbr: custNum,
        FromDepot: "false",
        AtpRequestDetail: [
          {
            PartNbr: this.sku,
            Qty: qty,
            RequestedDate: new Date()
          }
        ]
      };
      
      fetch(atpUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' 
        },
        body: JSON.stringify(requestObj) 
      })
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); 
      })
      .then(data => {
          console.log(data);
          const atpDetail = data.oResults.AtpRequestDetail[0];
          const atpDate = atpDetail.AtpDate;
          const tsdDate = atpDetail.TsdDate;
          const atpSuccess = atpDetail.AtpSuccess === "true"; // Convert to boolean
          const errorMessage = atpDetail.ErrorMessage || '';
      
          let shipDate, deliveryDate;
      
          // Check if error message contains "bad part"
          if (errorMessage.includes("Bad part")) {
              console.log("Bad part error");
              shipDate = "TBD";
              deliveryDate = ""; // No need to set delivery date if ship date is TBD
      
              this.querySelector('.ship-date').value = shipDate;
              this.querySelector('.delivery-date').value = deliveryDate;
              this.querySelector('.prev-page').value = document.referrer;
              this.querySelector('.current-page').value= window.location.href;              
              return; // Exit early as further processing is not needed
          }
      
          // Check if AtpDate is blank
          if (atpDate === '' || atpDate === null || atpDate === 'undefined') {
              // AtpDate is blank
              if (tsdDate === '' || tsdDate === null || tsdDate === 'undefined') {
                  // Both AtpDate and TsdDate are blank
                  if (atpSuccess) {
                      // Case 1: Both blank, AtpSuccess true
                      console.log(`AtpDate = blank , TsdDate = blank , AtpSuccess = true`);
                      const tomorrow = new Date();
                      tomorrow.setDate(tomorrow.getDate() + 1);
                      tomorrow.setUTCHours(0, 0, 0, 0);
                      shipDate = this.formatDate(tomorrow);
      
                      const delivery = new Date(tomorrow);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
      
                  } else {
                      // Case 2: Both blank, AtpSuccess false
                      console.log(`AtpDate = blank , TsdDate = blank , AtpSuccess = false`);
                      const futureDate = new Date();
                      futureDate.setDate(futureDate.getDate() + 21);
                      futureDate.setUTCHours(0, 0, 0, 0);
                      shipDate = this.formatDate(futureDate);
      
                      const delivery = new Date(futureDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
                  }
      
              } else {
                  // TsdDate is specific
                  if (atpSuccess) {
                      // Case 3: AtpDate blank, TsdDate specific, AtpSuccess true
                      console.log(`AtpDate = blank , TsdDate = ${tsdDate} , AtpSuccess = true`);
                      shipDate = this.formatDate(new Date(tsdDate));
      
                      const delivery = new Date(tsdDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
      
                  } else {
                      // Case 4: AtpDate blank, TsdDate specific, AtpSuccess false
                      console.log(`AtpDate = blank , TsdDate = ${tsdDate} , AtpSuccess = false`);
                      const futureDate = new Date();
                      futureDate.setDate(futureDate.getDate() + 21);
                      futureDate.setUTCHours(0, 0, 0, 0);
                      shipDate = this.formatDate(futureDate);
      
                      const delivery = new Date(futureDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
                  }
              }
      
          } else {
              // AtpDate is specific
              if (tsdDate === '' || tsdDate === null || tsdDate === 'undefined') {
                  // TsdDate is blank
                  if (atpSuccess) {
                      // Case 5: AtpDate specific, TsdDate blank, AtpSuccess true
                      console.log(`AtpDate = ${atpDate} , TsdDate = blank , AtpSuccess = true`);
                      shipDate = this.formatDate(new Date(atpDate));
      
                      const delivery = new Date(atpDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
      
                  } else {
                      // Case 6: AtpDate specific, TsdDate blank, AtpSuccess false
                      console.log(`AtpDate = ${atpDate} , TsdDate = blank , AtpSuccess = false`);
                      shipDate = this.formatDate(new Date(atpDate));
      
                      const delivery = new Date(atpDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
                  }
      
              } else {
                  // Both AtpDate and TsdDate are specific
                  if (atpSuccess) {
                      // Case 7: AtpDate specific, TsdDate specific, AtpSuccess true
                      console.log(`AtpDate = ${atpDate} , TsdDate = ${tsdDate} , AtpSuccess = true`);
                      shipDate = this.formatDate(new Date(tsdDate));
                      const delivery = new Date(tsdDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
                  } else {
                      // Case 8: AtpDate specific, TsdDate specific, AtpSuccess false
                      console.log(`AtpDate = ${atpDate} , TsdDate = ${tsdDate} , AtpSuccess = false`);
                      shipDate = this.formatDate(new Date(atpDate));
                      const delivery = new Date(atpDate);
                      delivery.setDate(delivery.getDate() + 5); // +4 days
                      delivery.setUTCHours(0, 0, 0, 0);
                      deliveryDate = this.formatDate(delivery);
                  }
              }
          }
      
          // Set values if shipDate is not "TBD"
          if (shipDate !== "TBD") {
              this.querySelector('.ship-date').value = shipDate;
              this.querySelector('.delivery-date').value = deliveryDate;
              this.querySelector('.current-date').value = new Date();
              this.querySelector('.prev-page').value = document.referrer;
              this.querySelector('.current-page').value= window.location.href;              
          } else {
              // Ship date is "TBD", so delivery date is not set
              this.querySelector('.ship-date').value = shipDate;
              this.querySelector('.prev-page').value = document.referrer;
              this.querySelector('.current-page').value= window.location.href;              
          }
      })
      .catch(error => {
        console.error('Error fetching data:', error); 
          if (error.message.includes('503')) {
            console.log("503 error: Service unavailable, setting custom shipping and delivery dates");
      
            // Custom logic for 503 errors
            const requestedDate = new Date();
            
            // Set ship date to +2 days from requested date
            const shipDate = new Date(requestedDate);
            shipDate.setDate(shipDate.getDate() + 2);  // +2 days
      
            // Set delivery date to +4 days from ship date
            const deliveryDate = new Date(shipDate);
            deliveryDate.setDate(deliveryDate.getDate() + 4);  // +4 days
      
            this.querySelector('.ship-date').value = this.formatDate(shipDate);
            this.querySelector('.delivery-date').value = this.formatDate(deliveryDate);
            this.querySelector('.current-date').value = requestedDate;  // Keep track of the request date
            this.querySelector('.prev-page').value = document.referrer;
            this.querySelector('.current-page').value= window.location.href;            
          }        
      }).finally(() => {
         this.onSubmitHandler();
      });
    }    

    onSubmitHandler(evt) {
      //evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
